var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutPublic',{attrs:{"title":_vm.$t('404.title'),"subtitle":_vm.$t('404.subtitle')}})}
var staticRenderFns = []

export { render, staticRenderFns }